<template>
  <div>
    <el-card>
      <el-row>
        <el-col>
          <!-- <el-date-picker
            v-model="times"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker> -->

          <el-date-picker
            v-model="starttime"
            type="datetimerange"
            @change="datePickerChange"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-button
            type="goon"
            style="margin-left: 20px"
            @click="GetHe_FoodEverydayList"
            >查询</el-button
          >
          <!-- <el-button type="goon" @click="starttime = []">清空</el-button> -->
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-button type="goon" style="margin-right: 35px" @click="onClickOpen"
        >上报今日食材</el-button
      >
      <el-button
        type="goon"
        style="margin-right: 35px"
        @click="dialogVisibleImport = true"
        >批量导入多日食材</el-button
      >
      <el-button type="goon" style="margin-right: 35px" @click="onStudentExeal"
        >模版下载</el-button
      >
      <el-button type="goon" style="margin-right: 35px" @click="onAllEdit"
        >批量修改当月食材</el-button
      >
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column
          prop="ReportDateString"
          label="应上报日期"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ActualTimeString"
          label="上报时间"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="Reporter" label="上报人" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="color: #4083fe"
              @click="onEditData(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="onClickDelete(scope.row)"
              style="color: #e14747"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </el-card>
    <!-- 批量 -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="70%">
      <div>
        <el-table
          :data="addTableData"
          style="width: 100%"
          :header-cell-style="{
            background: '#F2F5FF',
            color: '#333',
            'text-align': 'center',
          }"
          border
        >
          <el-table-column prop="FoodLibName" label="食材名称" align="center">
          </el-table-column>
          <el-table-column prop="FoodTypeName" label="食材分类" align="center">
          </el-table-column>
          <el-table-column label="1" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item1"
                v-model="scope.row.Item1.Value"
                @input="onChangeInput(scope.row.Item1, scope.row)"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="2" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item2"
                @input="onChangeInput(scope.row.Item2, scope.row)"
                v-model="scope.row.Item2.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="3" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item3"
                v-model="scope.row.Item3.Value"
                @input="onChangeInput(scope.row.Item3, scope.row)"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="4" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item4"
                v-model="scope.row.Item4.Value"
                @input="onChangeInput(scope.row.Item4, scope.row)"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="5" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item5"
                v-model="scope.row.Item5.Value"
                @input="onChangeInput(scope.row.Item5, scope.row)"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="6" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item6"
                @input="onChangeInput(scope.row.Item6, scope.row)"
                v-model="scope.row.Item6.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="7" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item7"
                @input="onChangeInput(scope.row.Item7, scope.row)"
                v-model="scope.row.Item7.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="8" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item8"
                @input="onChangeInput(scope.row.Item8, scope.row)"
                v-model="scope.row.Item8.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="9" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item9"
                @input="onChangeInput(scope.row.Item9, scope.row)"
                v-model="scope.row.Item9.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="10" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item10"
                @input="onChangeInput(scope.row.Item10, scope.row)"
                v-model="scope.row.Item10.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="11" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item11"
                @input="onChangeInput(scope.row.Item11, scope.row)"
                v-model="scope.row.Item11.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="12" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item12"
                @input="onChangeInput(scope.row.Item12, scope.row)"
                v-model="scope.row.Item12.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="13" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item13"
                @input="onChangeInput(scope.row.Item13, scope.row)"
                v-model="scope.row.Item13.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="14" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item14"
                @input="onChangeInput(scope.row.Item14, scope.row)"
                v-model="scope.row.Item14.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="15" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item15"
                @input="onChangeInput(scope.row.Item15, scope.row)"
                v-model="scope.row.Item15.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="16" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item16"
                @input="onChangeInput(scope.row.Item16, scope.row)"
                v-model="scope.row.Item16.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="17" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item17"
                @input="onChangeInput(scope.row.Item17, scope.row)"
                v-model="scope.row.Item17.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="18" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item18"
                @input="onChangeInput(scope.row.Item18, scope.row)"
                v-model="scope.row.Item18.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="19" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item19"
                @input="onChangeInput(scope.row.Item19, scope.row)"
                v-model="scope.row.Item19.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="20" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item20"
                @input="onChangeInput(scope.row.Item20, scope.row)"
                v-model="scope.row.Item20.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="21" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item21"
                @input="onChangeInput(scope.row.Item21, scope.row)"
                v-model="scope.row.Item21.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="22" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item22"
                @input="onChangeInput(scope.row.Item22, scope.row)"
                v-model="scope.row.Item22.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="23" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item23"
                @input="onChangeInput(scope.row.Item23, scope.row)"
                v-model="scope.row.Item23.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="24" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item24"
                @input="onChangeInput(scope.row.Item24, scope.row)"
                v-model="scope.row.Item24.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="25" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item25"
                @input="onChangeInput(scope.row.Item25, scope.row)"
                v-model="scope.row.Item25.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="26" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item26"
                @input="onChangeInput(scope.row.Item26, scope.row)"
                v-model="scope.row.Item26.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="27" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item27"
                @input="onChangeInput(scope.row.Item27, scope.row)"
                v-model="scope.row.Item27.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="28" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item28"
                @input="onChangeInput(scope.row.Item28, scope.row)"
                v-model="scope.row.Item28.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="29" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item29"
                @input="onChangeInput(scope.row.Item29, scope.row)"
                v-model="scope.row.Item29.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="30" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item30"
                @input="onChangeInput(scope.row.Item30, scope.row)"
                v-model="scope.row.Item30.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="31" align="center">
            <template slot-scope="scope">
              <el-input
                v-if="scope.row.Item31"
                @input="onChangeInput(scope.row.Item31, scope.row)"
                v-model="scope.row.Item31.Value"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="合计" prop="Count" align="center">
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="goon" @click="dialogVisible = false">提 交</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="dialogVisibleImport">
      <el-upload
        class="image-uploader"
        :multiple="false"
        :auto-upload="true"
        list-type="excel"
        :show-file-list="true"
        :drag="true"
        action
        :limit="1"
        :on-exceed="handleExceed"
        :before-upload="beforeUpload"
        :http-request="uploadFile"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          一次只能上传一个文件，仅限excel格式，单文件不超过5MB
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleImport = false">取消</el-button>
        <el-button type="primary" @click="ImportStudent">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetHe_FoodEverydayList,
  DelHe_FoodEveryDay,
  FileUploadsExcel,
  ImportHe_FoodEveryDay,
  GetFoodEveryDayEditList,
  AddHe_FoodEveryDayDetail,
  UpdateHe_FoodEveryDayDetail,
} from "../../../api/api";
import { debounce } from "../../../../util/otherRenders";

export default {
  data() {
    return {
      tableData: [],
      addTableData: [
        {
          oneCassl: "豆腐",
          twoClass: "青菜类",
          dataArr: [
            {
              date: "",
              value: "",
            },
            {
              date: "",
              value: "",
            },
            {
              date: "",
              value: "",
            },
          ],
        },
      ],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      dialogVisible: false,
      dialogVisibleImport: false,
      Title: "",
      ruleForm: {
        date: "",
      },
      todayArr: [],
      starttime: [],
      excelurl: "",
      selectData: "",
      pickerOptions: {
        // 点击时，选择的是开始时间，也就是minDate
        onPick: ({ maxDate, minDate }) => {
          this.selectData = minDate.getTime();
          if (maxDate) {
            // 解除限制
            this.selectData = "";
          }
        },
        disabledDate: (time) => {
          // 是否限制的判断条件
          if (!this.isNull(this.selectData)) {
            var date = new Date(this.selectData);
            // 这里就是限制的关键，大于或者小于本月的日期被禁用
            return (
              date.getMonth() > new Date(time).getMonth() ||
              date.getMonth() < new Date(time).getMonth()
            );
          } else {
            return false;
          }
        },
      },
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);

    await this.getNowTime();
    await this.GetHe_FoodEverydayList();
  },
  methods: {
    async refreshAll(val, item) {
      if (val.Id == 0) {
        // 添加
        const params = {
          weightType: "净",
          reporter: this.userInfo.uRealName,
          reportDateString: val.ReportDate,
          schoolId: this.userInfo.SchoolId,
          he_FoodLibraryId: item.FoodLibId,
          he_FoodLibraryName: item.FoodLibName,
          weight: val.Value,
        };
        let res = await AddHe_FoodEveryDayDetail(params);
        if (res.data.success) {
          val.Id = res.data.response;
        }
      } else {
        const params = {
          Id: val.Id,
          weightType: "净",
          reporter: this.userInfo.uRealName,
          reportDateString: val.ReportDate,
          schoolId: this.userInfo.SchoolId,
          he_FoodLibraryId: item.FoodLibId,
          he_FoodLibraryName: item.FoodLibName,
          weight: val.Value,
        };
        let xhr = await UpdateHe_FoodEveryDayDetail(params);
        if (xhr.data.success) {
          val.Id = xhr.data.response;
        }
      }
    },
    async onChangeInput(val, item) {
      if (window.lazy) {
        window.clearTimeout(window.lazy);
      }
      window.lazy = window.setTimeout(() => {
        this.refreshAll(val, item);
      }, 500);
    },
    datePickerChange(e) {
      ;
    },
    // 检查是否为空
    isNull(value) {
      if (value) {
        return false;
      }
      return true;
    },
    onEditData(item) {
      this.$router.push({
        path: "/Fitness/DataEntry/today_food",
        query: {
          Id: item.Id,
        },
      });
    },
    onStudentExeal() {
      location.href =
        "http://www.mushroomisland.cn/exceldown/%E8%98%91%E8%8F%87%E5%B2%9BV3%E6%AF%8F%E6%97%A5%E9%A3%9F%E6%9D%90%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";
    },
    //上传文件
    ImportStudent() {
      if (this.excelurl) {
        ImportHe_FoodEveryDay({
          fileName: this.excelurl,
          Uid: this.userInfo.uID,
          SchoolId: this.userInfo.SchoolId,
          UserName: this.userInfo.uRealName,
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "成功",
              type: "success",
            });
            //初始化数据
            this.dialogVisibleImport = false;
            this.GetHe_FoodEverydayList();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: "请选择文件",
          type: "error",
        });
      }
    },
    //导入
    uploadFile(item) {
      //console.log(item);
      //    //console.log(this.comId);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      //    form.append("comId", this.comId);
      form.append("filetype", "excel");
      // //console.log(form);
      //debugger;
      FileUploadsExcel(form).then((res) => {
        this.excelurl = res.data.url;
        // //console.log(this.excelurl);
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    // 上传文件个数超过定义的数量
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    beforeUpload(file) {
      //console.log("beforeUpload");
      // //console.log(file.type);
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      return isText | isTextComputer;
    },
    onClickDelete(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DelHe_FoodEveryDay({ ids: [row.Id] });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetHe_FoodEverydayList();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    async GetHe_FoodEverydayList() {
      const params = {
        Id: this.userInfo.SchoolId,
        StartDate: this.starttime[0],
        EndDate: this.starttime[1],
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
      };
      let res = await GetHe_FoodEverydayList(params);
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    async getNowTime() {
      let date = new Date();
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      let time = y + "-" + m + "-" + d;

      this.starttime.push(time);
      this.starttime.push(time);
      // conosle.log(this.starttime)
    },
    //   上报今日食材
    onClickOpen() {
      this.$router.push({
        path: "/Fitness/DataEntry/today_food",
        query: {
          Id: 0,
        },
      });
    },
    async onAllEdit() {
      const params = {
        SchoolId: this.userInfo.SchoolId,
        StartDate: this.starttime[0],
        EndDate: this.starttime[1],
      };
      let res = await GetFoodEveryDayEditList(params);
      if (res.data.success) {
        this.addTableData = res.data.response;
        this.dialogVisible = true;
      }
    },

    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetHe_FoodEverydayList();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetHe_FoodEverydayList();
    },
    onClickAdd() {
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
</style>